import useModal from 'hooks/useModal';
import { FV } from './ActivityForm/share';
import { DrawerProps } from 'antd';
import { Store } from 'components/StoreScopes';
import createNamedContext from 'utils/createNamedContext';

export function useActivityModal() {
  return useModal<{
    activity?: FV;
    activities?: Knowledge.Activity.WithExtra[];
    disabled?: boolean;
    drawerProps?: DrawerProps;
    scenarioConfigEnable?: boolean;
    onUpdate?: () => void;
    onUpdatePolicy?: () => void;
  }>();
}

export interface ActivityContextValue {
  show: ReturnType<typeof useActivityModal>['show'];
  storeList: Store[];
  storeMap: Partial<Record<number, Store>>;
  activityTypeHighlightListMap: Partial<
    Record<Knowledge.Activity.Type, Knowledge.Activity.RecommendHighlight[]>
  >;
}

export const ActivityContext = createNamedContext<ActivityContextValue | null>(
  'ActivityContext',
  null,
);
